module.exports = __webpack_public_path__ + "65b56e641b6b0f6c797ed66c37aad160.MP3";